export default "__VITE_ASSET__BftFsRN___"